module.exports = __webpack_public_path__ + "static/media/sm-logo-trnspt-3.1f268260.png";